import React, {useState} from 'react';
import {Modal, ModalBody, ModalHeader, Button} from 'reactstrap';
import {formatDateWithTime, numberWithCommas, textTruncateByLength} from 'utils/other';
import moment from 'moment';
import './sourcePreviewModal.scss';

const SourcePreviewModal = (props) => {
    const {source, handleIconDisplay, handleInfluenceDisplay, handleInfluenceSuffix, isOpen, toggle, type} = props;
    const [backToTopBtnVisible, setBackToTopBtnVisible] = useState(false);

    const scrollToTop = (e) => {
        if(e.nativeEvent.target.tagName === 'I') {
            return (e.nativeEvent.target.parentElement.parentElement.scrollTop = 0);
        }
        e.nativeEvent.target.parentElement.scrollTop = 0;
    };

    const handleCheckScroll = (e) => {
        const scrollCoordinates = e.nativeEvent.target.scrollTop;
        if(scrollCoordinates > 300) {
            setBackToTopBtnVisible(true);
        } else {
            setBackToTopBtnVisible(false);
        }
    };

    return (
        <Modal style={{height: '95vh'}} isOpen={isOpen} toggle={toggle}>
            <ModalHeader style={{padding: '10px 0 10px 15px'}} id="company-adding-preview-modalheader">
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    {source &&
                    <div style={{display: 'flex'}}>
                        {handleIconDisplay()}
                        <div style={{
                            marginLeft: '15px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}>
                            <div style={{fontSize: '16px', fontWeight: '700'}}>
                                {source.name ?
                                    textTruncateByLength(source.name, 50) :
                                    source.title ? textTruncateByLength(source.title, 50) :
                                        source.screenName ? textTruncateByLength(source.screenName, 50) : ''}
                            </div>
                            {
                                (source.type !== 'twitter' ||
                                    (source.type === 'twitter' && (source.twitterPageId || source.pageId))
                                ) &&
                                <div style={{display: 'flex', fontSize: '14px', wordBreak: 'break-all', marginRight: '.5rem'}}>
                                    {(source.screenName || source.name) &&
                                    <a
                                        style={{textDecoration: 'underline'}}
                                        href={source.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {textTruncateByLength(source.screenName, 50) || textTruncateByLength(source.name, 50)}
                                    </a>
                                    }
                                    {handleInfluenceDisplay()}
                                </div>
                            }
                        </div>
                    </div>
                    }
                    <div style={{maxWidth: '250px', fontSize: '14px'}}>
                        News posts that are older than 30 days will not appear on the Dashboard.
                    </div>
                    <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={toggle}
                        style={{padding: '10px 20px', height: '100%', margin: '0'}}
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="modal-wrapper_container" onScroll={(e) => handleCheckScroll(e)}>
                    {source.news && source.news.length ? (
                        source.news.sort((a, b) => moment(b.publishedAt) - moment(a.publishedAt)).map((article, index) => (
                            <div className="news" key={index} style={{marginBottom: '12px'}}>
                                <a className="news_link" target="blank" href={article.url}>
                                    {article.title ? textTruncateByLength(article.title, 140)
                                        : (article.shortTitle ? textTruncateByLength(article.shortTitle, 140) : '')}
                                </a>
                                <br/>
                                {article.domain &&
                                <span style={{color: '#869fac', fontSize: '.775rem'}}>
                                        {article.domain + ' • '}
                                    </span>
                                }
                                {article.publishedAt && (
                                    <span style={{color: '#869fac', fontSize: '.775rem'}}>
                                        {formatDateWithTime(article.publishedAt, article) + '  '}
                                    </span>
                                )}
                                {type !== 'rss' && type !== 'google_ozmosys' && (
                                    // <a
                                    //     target="_blank"
                                    //     rel="noopener noreferrer"
                                    //     href={article.authorUrl ? article.authorUrl : article.url}
                                    //     style={{color: '#869fac', fontSize: '.775rem', textDecoration: 'underline'}}
                                    // >
                                    //     {article.domain ? article.domain : source.domain ? source.domain : ''}
                                    // </a>
                                    <>
                                        {article.authorScreenName &&
                                        <a
                                            style={{color: '#869fac', fontSize: '.775rem', textDecoration: 'underline'}}
                                            href={article.authorUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {article.authorScreenName}
                                        </a>
                                        }
                                    </>
                                )}
                                {Number.isInteger(article.influence) && (
                                    <span style={{color: '#869fac', fontSize: '.775rem'}}>
                                        {` (${numberWithCommas(article.influence)} ${handleInfluenceSuffix(article.influence)})`}
                                    </span>
                                )}
                                {(article.shortAbstract || article.abstract) && (
                                    <>
                                        <br/>
                                        <span>{article.shortAbstract || textTruncateByLength(article.abstract, 300)}</span>
                                    </>
                                )}
                            </div>
                        ))
                    ) : (
                        <div style={{fontWeight: '500'}}>No news posts were found for the last 30 days.</div>
                    )}
                    {backToTopBtnVisible && (
                        <Button onClick={(e) => scrollToTop(e)} style={{color: 'white', marginRight: 20}}
                                className="btnBackToTop">
                            <i className="fas fa-arrow-up"/>
                        </Button>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default SourcePreviewModal;
